import { useEffect, useRef } from 'react';
import { notification } from 'antd';
import cable from '../cable';

const usePortalNotifications = (onDocumentUploaded) => {
  const subscriptionRef = useRef(null);
  const onDocumentUploadedRef = useRef(onDocumentUploaded);
  onDocumentUploadedRef.current = onDocumentUploaded;

  useEffect(() => {
    if (subscriptionRef.current) return undefined;

    subscriptionRef.current = cable.subscriptions.create(
      { channel: 'NotificationsChannel' },
      {
        received: (data) => {
          if (data.type === 'document_uploaded') {
            notification.info({
              message: 'New Document Shared',
              description: `${data.uploaded_by_org} shared a document on a referral`,
              duration: 5,
            });

            if (onDocumentUploadedRef.current) {
              onDocumentUploadedRef.current(data);
            }
          }
        },
      },
    );

    return () => {
      if (subscriptionRef.current) {
        subscriptionRef.current.unsubscribe();
        subscriptionRef.current = null;
      }
    };
  }, []);

  return null;
};

export default usePortalNotifications;
